import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './TaskStatus.css';
import checked from './checked.png';

class TaskStatus extends Component {
  configuration = {
    rfp: {
      position: 0,
      total: 7,
    },
    plm: {
      position: 1,
      total: 7,
    },
    agg: {
      position: 2,
      total: 8,
    },
    woa: {
      position: 2,
      total: 7,
    },
    pre: {
      position: 3,
      total: 7,
    },
    wip: {
      position: 4,
      total: 7,
    },
    cmp: {
      position: 5,
      total: 7,
    },
    cls: {
      position: 6,
      total: 7,
    },
  };

  static propTypes = {
    status: PropTypes.string.isRequired,
  };

  render() {
    const total = this.configuration[this.props.status].total;
    const position = this.configuration[this.props.status].position;
    let elements = [];

    let key = 0;
    for (let i = 0; i < total; i++) {
      if (i === position) {
        elements.push(
          <div key={key} className="selected-circle">
            <div className={'circle ' + this.props.status} />
          </div>
        );
      } else if (i < position) {
        elements.push(<img key={key} src={checked} alt={'checked'} />);
      } else {
        elements.push(<div key={key} className="circle" />);
      }
      key++;

      if (i < total - 1) {
        elements.push(<hr key={key} />);
      }
      key++;
    }

    return (
      <div className="task-status">
        <div className={'status-text ' + this.props.status}>
          {this.props.status.toUpperCase()}
        </div>
        {elements}
      </div>
    );
  }
}

export default TaskStatus;



// WEBPACK FOOTER //
// ./src/components/shared/task-status/TaskStatus.js